import { createFileRoute } from "@tanstack/react-router";

import { AdminDashboardPage } from "@/features/admin/dashboard-page";
import { adminDashboardQueryOptions } from "@/features/admin/queries";

// ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
export const Route = createFileRoute("/_authenticated/admin/")({
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(adminDashboardQueryOptions());
  },
  component: AdminDashboardPage,
});
